<template>
	<div class="section full services">
		<slide-y-up-transition>
			<div v-show="showFirst" class="services-content">
				<div class="logo-top">
					Inter-<br>national
					<div class="details">We work with international<br>Influencers for all kind of projects</div>
				</div>
				<div class="left-right">
					<div class="logo-left">
						Marketing<br>Strategy
						<div class="details">We search for the best marketing stra-<br>tegy for all of your business projects</div>
					</div>
					<div class="logo-right">
						High Brands<br>Impact
						<div class="details">We provide high brands impact due<br>to our strong Influencers' notoriety</div>
					</div>
				</div>
				<div class="logo-bottom">
					Big<br>Influencers
					<div class="details">We work with big and recognized<br>Influencers with large communities</div>
				</div>

				<div class="details-mobile">We work with international Influencers for all kind of projects</div>
				<div class="details-mobile">We search for the best marketing strategy for all of your business projects</div>
				<div class="details-mobile">We provide high brands impact due to our strong Influencers' notoriety</div>
				<div class="details-mobile">We work with big and recognized Influencers with large communities</div>
			</div>
		</slide-y-up-transition>
		<fade-transition>
			<div v-show="showSecond" class="bottom">
				<div class="container">
					<div class="social">
						<router-link to="/contact"><span class="instagram"></span></router-link>
						<!-- <router-link to="/contact"><span class="facebook"></span></router-link> -->
					</div>
					<div class="author">
						<!-- <i>Manon Tanti</i>
						<br>
						&copy; Anthony Passant -->
					</div>
				</div>
			</div>
		</fade-transition>
	</div>
</template>

<script>
export default {
	data () {
		return {
			showFirst: false,
			showSecond: false,
			showThird: false,
		}
	},
	mounted () {
		setTimeout(() => {
			this.showFirst = true
		}, 200)
		setTimeout(() => {
			this.showSecond = true
		}, 600)
		setTimeout(() => {
			this.showThird = true
		}, 900)
	}
}
</script>